<template>
  <page-header title="Мои проекты" icon="bi-gear-wide"/>
  <std-table
      :format="[
        ['project_id','ID проекта', (i)=>i.project_id],
        ['description','Описание', (i)=>i.description],
      ]"
      url="/myprojects"
      resource="myproject"
  />


</template>

<script>
import PageHeader from "@/components/PageHeader";
import StdTable from "@/components/StdTable";

export default {
  components: {StdTable, PageHeader},
}
</script>

